import { InjectionToken } from '@angular/core';

// as related service doesn't have a public interface, type is defined with `unknown`
export const META_DATA_SERVICE = new InjectionToken<unknown>('shared.util-core.MetaDataService');
